import { Box, alpha } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { AttachmentImageSize } from "ui/Scripts/source/models/enums";
import { DownloadToolButton } from "../../framework/Button/DownloadToolButton";
import { PopupMenu } from "../../framework/PopupMenu";
import { RemoveToolButton } from "source/components/framework/Button/RemoveToolButton";

interface IAttachmentImageProp {
    imageSize?: AttachmentImageSize;
    lateThreshold: number;
    attachment: IFileAttachment;
    selectedId?: string;
    isReadOnly?: boolean;
    ignoreAspectRatio?: boolean;
    onClick?: (id: string) => void;
    onDoubleClick?: (id: string) => void;
    onDownload?: (id: string) => void;
    onRemove?: (id: string) => void;
}

export const AttachmentImage = ({
    imageSize,
    lateThreshold,
    attachment,
    selectedId,
    isReadOnly,
    ignoreAspectRatio,
    onClick,
    onDoubleClick,
    onDownload,
    onRemove,
}: IAttachmentImageProp) => {
    const timeToleranceInJsTicks = 500;
    const isLate = !Base.isNullOrUndefined(lateThreshold) && attachment.modifyDate > (lateThreshold + timeToleranceInJsTicks);
    const [hovered, setHovered] = React.useState(false);
    
    return (
        <Box
            className={"attachmentImage" + (isLate ? " late" : "") + (attachment.id === selectedId ? " selected" : "") + (imageSize === AttachmentImageSize.Large ? " large" : "")}
            onClick={onClick ? () => { onClick(attachment.id); } : null}
            onDoubleClick={onDoubleClick ? () => { onDoubleClick(attachment.id); } : null}
            title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={(theme) => ({
                "cursor": "default",
                "display": "flex",
                "justifyContent": "center",
                "alignItems": "center",
                "height": imageSize === AttachmentImageSize.Large ? "auto" : "111px",
                "width": imageSize === AttachmentImageSize.Large ? "100%" : "145px",
                "aspectRatio": (imageSize === AttachmentImageSize.Large && !ignoreAspectRatio) ? 1.31 : undefined,
                "padding": (imageSize === AttachmentImageSize.Large && !ignoreAspectRatio) ? undefined : ".5rem 0",
                "position": "relative",
                "borderRadius": "8px",
                "&:hover": {
                    background: attachment.id === selectedId
                        ? alpha(
                            theme.palette.primary.main,
                            theme.palette.action.selectedOpacity +
                                theme.palette.action.hoverOpacity
                        )
                        : theme.palette.action.hover
                }
            })}
        >
            <Box
                component="img"
                src={attachment.thumbnail}
                alt={attachment.name}
                sx={{
                    maxHeight: imageSize === AttachmentImageSize.Large ? "calc(100% - 10px)" : "101px",
                    maxWidth: imageSize === AttachmentImageSize.Large ? "calc(100% - 10px)" : "135px",
                }}
            />
            {hovered && (
                <PopupMenu>
                    <DownloadToolButton onClick={() => onDownload(attachment.id)}></DownloadToolButton>
                    {!isReadOnly && (
                        <RemoveToolButton onClick={() => onRemove(attachment.id)} />
                    )}
                </PopupMenu>
            )}
        </Box>
    );
};
